export interface CompanyCustomEmailDomainRecordModel {
  type: string | null;
  host: string | null;
  value: string | null;
  priority: number | null;
  is_valid: boolean | null;
}

export interface EmailDomainDNSModel {
  id: string;
  company_id: string;
  domain: string | null;
  is_valid: boolean | null;
  error_message: string | null;
  records: CompanyCustomEmailDomainRecordModel[] | null;
}

export interface EmailDomainDNSEmailModel {
  id: string;
  email: string | null;
  domain_name: string | null;
  sender_name: string | null;
  valid: boolean | null;
  domain_id: string;
  inserted: string;
  readonly full_email?: string | null;
}

export interface EmailDomainDNSEmailValidateModel {
  id: string;
  validation_code: string | null;
}
